import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './Navbar.css';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import Logo from '../assets/gorion.png';
import UserIcon from '../assets/user.png';
import API_BASE_URL from '../config';
import FaceEnrollModal from './FaceRecognition/FaceEnrollModal';

const Navbar = () => {
  const token = useSelector((state) => state.auth.token);
  const [user, setUser] = useState(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [userRole, setUserRole] = useState('');
  const [showEnrollModal, setShowEnrollModal] = useState(false);

  useEffect(() => {
  const fetchUser = async () => {
    if (!token) return;

    try {
      const decoded = jwtDecode(token);
      setUserRole(decoded.rol || '');
      const noColaborador = decoded.id;

      // 1. Intenta con colaboradores
      try {
        const res = await axios.get(`${API_BASE_URL}api/colaboradores/${noColaborador}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser({ ...res.data, tipo: 'colaborador' });
        return; // 👈 Si lo encuentra, salimos
      } catch (errColab) {
        if (errColab.response?.status !== 404) {
          throw errColab; // Otro error inesperado
        }
        // Silenciar si es 404 y pasar a operadores
      }

      // 2. Intenta con operadores
      try {
        const resOp = await axios.get(`${API_BASE_URL}api/operadores/${noColaborador}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser({ ...resOp.data, tipo: 'operador' });
        return;
      } catch (errOp) {
        if (errOp.response?.status !== 404) {
          throw errOp;
        }
        // Mostrar solo si no se encontró en ninguno
        console.error(`❌ No se encontró el usuario ${noColaborador} en colaboradores ni operadores`);
      }

    } catch (error) {
      console.error('Error al obtener la información del usuario:', error);
    }
  };

  fetchUser();
}, [token]);


  const toggleDropdown = () => setIsDropdownVisible(!isDropdownVisible);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-left">
          <div className="brand-logo-text-wrapper">
            <img src={Logo} alt="Logo Orión" className="navbar-logo-right" />
            <div className="brand-text-container">
              <span className="brand-title">Grupo Orión</span>
              <span className="brand-subtitle">MINTAKA CORE</span>
            </div>
          </div>
        </div>

        {/* Menú */}
        <div className="navbar-center">
          <div className="navbar-menu desktop-menu">
            {userRole === 'colaborador' && <span className="menu-item active-text">COORDINACIÓN</span>}
            {userRole === 'operador' && <span className="menu-item active-text">HANDHELD</span>}
          </div>
          <button className="hamburger" onClick={toggleMenu}>&#9776;</button>
          {isMenuOpen && (
            <div className="navbar-menu mobile-menu">
              {userRole === 'colaborador' && <span className="menu-item active-text">COORDINACIÓN</span>}
              {userRole === 'operador' && <span className="menu-item active-text">HANDHELD</span>}
            </div>
          )}
        </div>

        {/* Usuario */}
        <div className="navbar-right">
          <div className="navbar-user" onClick={toggleDropdown}>
            <img src={UserIcon} alt="User Icon" className="user-icon" />
          </div>

          {isDropdownVisible && user && (
            <div className="dropdown-user">
              <div className="dropdown-header">
                <img
                  src={user.fotoPerfil ? `https://app.orionadministracion.com${user.fotoPerfil}` : UserIcon}
                  alt="User Avatar"
                  className="dropdown-avatar"
                />
                <span>{user.nombre} {user.apellidos}</span>
              </div>
              <div className="dropdown-details">
                <p><strong>Estación:</strong> {user.estacion}</p>
                <p><strong>Área:</strong> {user.area || 'N/A'}</p>
                <p><strong>Puesto:</strong> {user.puesto || 'N/A'}</p>
              </div>
              <div className="dropdown-footer">
                {userRole === 'colaborador' && (
                  <button
                    className="btn-enroll-face"
                    onClick={() => { setIsDropdownVisible(false); setShowEnrollModal(true); }}
                  >
                    <i className="fa fa-camera" style={{ marginRight: 6 }} />
                    Registrar rostro
                  </button>
                )}
                <button className="btn-logout" onClick={handleLogout}>Cerrar sesión</button>
              </div>
            </div>
          )}

          {showEnrollModal && (
            <FaceEnrollModal onClose={() => setShowEnrollModal(false)} />
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
